import React, { Component } from 'react';
// import Datas from '../../data/service/details.json';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/service.js';
import axios from 'axios';

class Services extends Component {
    constructor(props) {
        super(props);
        this.state = {homePageService: []}
    }
    componentDidMount(){
        document.title = "Our Services | REAL FM";
        const getHomePageService = async () => {
            await axios.get(`${process.env.REACT_APP_API_URL}/real-fm/api/v1/homepage-services/find-all`).then((res) => {
                // console.log("Slider" + res.data);
                this.setState({homePageService: res.data});
            }).catch(error => {
                console.error(error);
            });
        };
        getHomePageService();
    }
    render() {
        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper instructor-details-page">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Breadcroumb */}
                    <BreadcrumbBox title="Our Services" />

                    {/* Instructor Details Area */}
                    <section className="instructor-details-area">
                    <Container className="card custom-card">
                            <Row>
                               
                                <Col md="12">
                                    <div className="instructor-content">
                                        <h2>You’re in great hands…</h2><br></br>
                                        <h3>RealFM Building Management is an essential investment in your financial security and harmonious community living.</h3>
                                        <p className="first-p">Our specialised professionals provide Building Management and Facility Management services to Residential and Commercial buildings throughout the Sydney Metropolitan area.</p>
                                        <p className="second-p">Management and knowledge of complex buildings, BMC structures, By-laws, levy cost centres, and strata plans by our team ensures we can deliver an outstanding building management service.</p>
                                    </div>
                                    
                                </Col>
                                <Col md="12">
                                    <div className="instructor-course-title">
                                        <h4>Our Services Includes</h4>
                                    </div>
                                    <div className="instructor-course-slider">
                                        <Row>
                                            
                                                {
                                                    this.state.homePageService &&  this.state.homePageService.length > 0 ?  this.state.homePageService.map((data, i) => (
                                                    <Col lg="4" md="6" key={i} data-id={data.targetId}>
                                                        <div className="course-item" key={i}>
                                                            <Link to={process.env.PUBLIC_URL + data.urlSlug}>
                                                                <div className="course-image" 
                                                                style={{backgroundImage: `url(${process.env.REACT_APP_API_BASE_URL.substring(0, process.env.REACT_APP_API_BASE_URL.indexOf("/api")) + `${data.serviceImg.substring(data.serviceImg.indexOf("/uploads"))}`})`}}>
                                                                    
                                                                </div>
                                                            </Link>
                                                            <div className="course-content">
                                                                <h6 className="heading"><Link to={process.env.PUBLIC_URL + data.urlSlug}>{data.serviceName}</Link></h6>
                                                                
                                                            </div>
                                                        </div>
                                                        </Col>

                                                    )) : "No services found"
                                                }
                                        </Row>
                                            
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>

                    {/* Footer 2 */}
                    <FooterTwo />

                </div>
            </Styles>
        )
    }
}

export default Services